import React, { useState } from 'react';
import { Button } from '../ui/button';
import { MapPin, Calculator, Plus } from 'lucide-react';
import TerritoryCheckerWidget from './TerritoryCheckerWidget';
import CommercialsCalculatorDialog from './CommercialsCalculatorDialog';

/**
 * Floating action panel — globally accessible widgets for the executive:
 *   1. Check Territory Availability  (pincode/city availability)
 *   2. Franchise Commercials Calculator (ROI + PDF quote)
 */
const FloatingTools = () => {
  const [territoryOpen, setTerritoryOpen] = useState(false);
  const [calcOpen, setCalcOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {/* Compact floating panel bottom-right — collapsed to a single FAB by default so it never overlaps page content; expands on click */}
      <div className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col items-end gap-2">
        {expanded && (
          <>
            <Button
              size="sm"
              className="rounded-full shadow-lg bg-emerald-600 hover:bg-emerald-700 text-white pr-4 animate-in fade-in slide-in-from-bottom-2"
              onClick={() => { setTerritoryOpen(true); setExpanded(false); }}
              data-testid="floating-territory-btn"
              title="Check Territory Availability"
            >
              <MapPin className="h-4 w-4 mr-1.5" /> Territory
            </Button>
            <Button
              size="sm"
              className="rounded-full shadow-lg bg-sky-600 hover:bg-sky-700 text-white pr-4 animate-in fade-in slide-in-from-bottom-2"
              onClick={() => { setCalcOpen(true); setExpanded(false); }}
              data-testid="floating-calc-btn"
              title="Franchise Commercials Calculator"
            >
              <Calculator className="h-4 w-4 mr-1.5" /> Calculator
            </Button>
          </>
        )}
        <Button
          size="icon"
          className={`rounded-full shadow-lg w-11 h-11 transition-transform ${expanded ? 'bg-slate-700 hover:bg-slate-800 rotate-45' : 'bg-slate-800 hover:bg-slate-900'}`}
          onClick={() => setExpanded(v => !v)}
          data-testid="floating-tools-toggle"
          title="Quick tools"
        >
          <Plus className="h-5 w-5 text-white" />
        </Button>
      </div>
      <TerritoryCheckerWidget open={territoryOpen} onClose={() => setTerritoryOpen(false)} />
      <CommercialsCalculatorDialog open={calcOpen} onClose={() => setCalcOpen(false)} lead={null} />
    </>
  );
};

export default FloatingTools;
